import React from 'react'
import './index.scss';

function Popup(props) {
  return (props.trigger)?(
    <div className = "main">
        <div className = "popup">
            <div className = "popup-inner">
            
                <button className ="close-btn" onClick = {()=>props.setTrigger(false)}>close</button>
                {props.children}
            </div>
        </div>
 
    </div>
  ):"";
}

export default Popup;